import { DialogConfig } from '@/core/types';

class SimpleEventEmitter {
  private listeners: { [key: string]: ((...args: any[]) => void)[] } = {};

  on(event: string, listener: (...args: any[]) => void) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(listener);
    return () => this.off(event, listener);
  }

  off(event: string, listener: (...args: any[]) => void) {
    if (!this.listeners[event]) return;
    this.listeners[event] = this.listeners[event].filter((l) => l !== listener);
  }

  emit(event: string, ...args: any[]) {
    if (!this.listeners[event]) return;
    this.listeners[event].forEach((listener) => listener(...args));
  }
}

const emitter = new SimpleEventEmitter();

export const dialogService = {
  show(config: DialogConfig) {
    return new Promise((resolve, reject) => {
      emitter.emit('show', { config, resolve, reject });
    });
  },
  close(result: any) {
    emitter.emit('close', result);
  },
  onShow(listener: (event: any) => void) {
    return emitter.on('show', listener);
  },
  onClose(listener: (event: any) => void) {
    return emitter.on('close', listener);
  },
};

export const showDialog = dialogService.show;
